import createRoutine from '@/utils/createRoutine'

export const plaidItemsRoutine = createRoutine('plaidItemsRoutine')

export const plaidGetters = {
  PLAID_ITEMS: 'PLAID_ITEMS',
  PLAID_STATUS: 'PLAID_STATUS',
  PLAID_ACCOUNTS: 'PLAID_ACCOUNTS'
}

export const PLAID_CLEANUP = 'PLAID_CLEANUP'
